// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".jd-company[data-v-0783afa2]{background-color:#fff!important;padding:20px}.jd-company[data-v-0783afa2]:not(:first-child){margin-top:10px}.jd-company .jd-company-label[data-v-0783afa2]{color:#909399!important;font-size:14px}.jd-company .jd-company-desc[data-v-0783afa2]{color:#606266!important;display:inline-block;font-size:14px;max-width:200px;overflow:hidden;text-overflow:ellipsis;vertical-align:bottom;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
